"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateWithI18Next = exports.initI18N = exports.getLanguage = exports.changeLanguage = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _i18nextChainedBackend = _interopRequireDefault(require("i18next-chained-backend"));
var _i18nextHttpBackend = _interopRequireDefault(require("i18next-http-backend"));
var _i18nextResourcesToBackend = _interopRequireDefault(require("i18next-resources-to-backend"));
var _locales = _interopRequireDefault(require("./locales"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initI18N = function initI18N(baseUrl, lang) {
  return _i18next["default"].use(_i18nextChainedBackend["default"]).init({
    load: "currentOnly",
    lng: lang,
    ns: ["translation"],
    backend: {
      backends: [_i18nextHttpBackend["default"], (0, _i18nextResourcesToBackend["default"])(function (lng, ns) {
        var _localTranslation$loc, _localTranslation$loc2;
        return _locales["default"] === null || _locales["default"] === void 0 ? void 0 : (_localTranslation$loc = _locales["default"].localTranslationData) === null || _localTranslation$loc === void 0 ? void 0 : (_localTranslation$loc2 = _localTranslation$loc[lng]) === null || _localTranslation$loc2 === void 0 ? void 0 : _localTranslation$loc2.translation;
      })],
      backendOptions: [{
        loadPath: "".concat(baseUrl, "/api/v1/i18n/{{lng}}")
      }]
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: true,
      useSuspense: false
    }
  }, function (err) {
    if (err) {
      console.error(err);
    }
  });
};
exports.initI18N = initI18N;
var changeLanguage = function changeLanguage(lng) {
  _i18next["default"].changeLanguage(lng);
};
exports.changeLanguage = changeLanguage;
var getLanguage = function getLanguage() {
  return _i18next["default"].language;
};
exports.getLanguage = getLanguage;
var translateWithI18Next = function translateWithI18Next(key, values) {
  return _i18next["default"].t(key, values);
};
exports.translateWithI18Next = translateWithI18Next;
window.i18TranslateReference = function () {
  return {
    initI18N: initI18N,
    changeLanguage: changeLanguage,
    getLanguage: getLanguage,
    translateWithI18Next: translateWithI18Next
  };
};